import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";

import vrFire from "../../Assets/Projects/VRFireTranning.jpg";
import vrFire1 from "../../Assets/Projects/VRFireTranning1.jpg";
import vrFire2 from "../../Assets/Projects/VRFireTranning2.jpg";

import forklift from "../../Assets/Projects/Forklift_VR.png";
import forklift1 from "../../Assets/Projects/Forklift1.png";
import forklift2 from "../../Assets/Projects/Forklift2.png";

import kingdom from "../../Assets/Projects/Kingdom.png";
import kingdom1 from "../../Assets/Projects/Kingdom_1.png";

import container from "../../Assets/Projects/Container.png";
import container1 from "../../Assets/Projects/Container2.png";

import pose1 from "../../Assets/Projects/Pose.png";
import pose2 from "../../Assets/Projects/Pose1.png";
import pose3 from "../../Assets/Projects/Pose2.png";

import knife1 from "../../Assets/Projects/FPS1.png";
import knife2 from "../../Assets/Projects/FPS2.png";

import wall1 from "../../Assets/Projects/Wall1.jpg";
import wall2 from "../../Assets/Projects/Wall2.jpg";
import wall3 from "../../Assets/Projects/Wall3.jpg";

import xe1 from "../../Assets/Projects/XeKhongKinh1.jpg";
import xe2 from "../../Assets/Projects/XeKhongKinh2.jpg";

import dauChan1 from "../../Assets/Projects/DauChanVR.jpg";
import dauChan2 from "../../Assets/Projects/DauchanVR1.png";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPaths={[xe1, xe2]}
              isBlog={true}
              title="LÁI XE KHÔNG KÍNH"
              description="Mô phỏng lái xe Trường Sơn lịch sử kết hợp buồng lái thật và kính VR. Ứng dụng trong bảo tàng số và giáo dục truyền thống, đã triển khai thành công tại Triển lãm 80 năm Quốc khánh (2025), thu hút đông đảo khách tham quan."
              ghLink="https://congthuong.vn/trai-nghiem-lai-xe-chien-truong-truong-son-giua-thoi-binh-417867.html"
              demoLink="https://youtu.be/ss6qMXWc9JU"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPaths={[dauChan1, dauChan2]}
              isBlog={true}
              title="DẤU CHÂN NGƯỜI LÍNH"
              description="Trải nghiệm VR nhập vai hành quân đường rừng. Ứng dụng tái hiện lịch sử sống động, phục vụ công tác trưng bày, giáo dục lòng yêu nước tại các sự kiện văn hóa - lịch sử trọng đại. Đã triển khai thành công tại Triển lãm 80 năm Quốc khánh (2025)."
              ghLink="https://baomoi.com/cho-3-tieng-de-di-xuyen-rung-truong-son-bang-kinh-vr-c53138657.epi"
              demoLink="https://youtu.be/ss6qMXWc9JU"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPaths={[wall1, wall2, wall3]}
              isBlog={false}
              title="WALL CLIMBING"
              description="Trò chơi leo núi tương tác kết hợp cảm biến chuyển động. Dự án đang được triển khai thực tế tại Crescent Mall, mang lại trải nghiệm vận động mới lạ và thu hút đông đảo khách hàng tham gia, đặc biệt là giới trẻ và trẻ em."
              ghLink=""
              demoLink="https://youtu.be/BOUKdvBrBco"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPaths={[pose1, pose2, pose3]}
              isBlog={false}
              title="STRIKE A POSE"
              description="Game tương tác vận động ứng dụng AI nhận diện hành vi (Pose Estimation). Giải pháp tối ưu cho quảng cáo ngoài trời (OOH) và kích hoạt thương hiệu (Brand Activation) tại các trung tâm thương mại, sự kiện."
              ghLink=""
              demoLink="https://youtu.be/ss6qMXWc9JU"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPaths={[vrFire, vrFire1, vrFire2]}
              isBlog={false}
              title="Fire Training VR"
              description="Giải pháp huấn luyện PCCC thực tế ảo. Ứng dụng trong các buổi diễn tập an toàn lao động tại doanh nghiệp, cho phép học viên thực hành dập lửa an toàn, tiết kiệm chi phí và loại bỏ rủi ro thực tế."
              ghLink=""
              demoLink="https://youtu.be/Bn-lpCCsvZw"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPaths={[forklift, forklift1, forklift2]}
              isBlog={false}
              title="Forklift Training VR"
              description="Hệ thống mô phỏng lái xe nâng VR chuẩn công nghiệp. Ứng dụng đào tạo nhân sự kho vận (Logistics), giúp học viên làm quen thao tác vận hành và quy tắc an toàn trước khi tiếp xúc với xe thật."
              ghLink=""
              demoLink="https://youtu.be/_5YCJNNbv9w"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPaths={[container, container1]}
              isBlog={false}
              title="Container Training"
              description="Phần mềm đào tạo quy trình chuẩn SOP. Ứng dụng trong đào tạo nhân viên cảng vụ và kho bãi, hướng dẫn chi tiết các bước đóng/mở container an toàn và hiệu quả."
              ghLink=""
              demoLink="https://youtu.be/tHoHeSX8k3k"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPaths={[kingdom, kingdom1]}
              isBlog={false}
              title="Tower Defense"
              description="Game chiến thuật 3D trên di động. Dự án thể hiện khả năng tối ưu hóa đồ họa và thuật toán tìm đường (Pathfinding) trong Unity, định hướng phát triển sản phẩm giải trí thương mại."
              ghLink=""
              demoLink="https://youtu.be/tujmkT3bx9M?si=SgrHG3xTu_I1SA5s"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPaths={[knife1, knife2]}
              isBlog={false}
              title="Knife Throwing"
              description="Game FPS trực tuyến nhiều người chơi. Ứng dụng kiến trúc Server-Authoritative nhằm bảo mật logic game, ngăn chặn gian lận (hack/cheat) trong các hệ thống thi đấu eSports."
              ghLink=""
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;